import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Accordion, 
  AccordionSummary, 
  AccordionDetails,
  Paper,
  Link
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqItems = [
  {
    question: "Kur naudojami mano įkelti duomenys?",
    answer: "Jūsų įkelti duomenys nėra kaupiami ar saugomi. Jie naudojami tik tam, kad būtų suteikta paslauga realiuoju laiku, o vėliau automatiškai ištrinami. Užtikriname, kad duomenys nėra perduodami trečiosioms šalims ar naudojami jokiems kitiems tikslams."
  },
  {
    question: "Kas gali pasinaudoti lengvata už studijų įmokas?",
    answer: "Lengvata gali pasinaudoti tik nuolatinis Lietuvos gyventojas, t. y. gyventojas, kuris:\n\n" +
           "• tą mokestinį laikotarpį Lietuvoje turi nuolatinę gyvenamąją vietą;\n" +
           "• kurio asmeninių, socialinių arba ekonominių interesų buvimo vieta tą mokestinį laikotarpį yra veikiau Lietuvoje negu užsienyje;\n" +
           "• kuris tą mokestinį laikotarpį Lietuvoje ištisai arba su pertraukomis išbuvo 183 ar daugiau dienų.\n\n" +
           "Daugiau informacijos: ",
    link: {
      text: "VMI svetainėje",
      url: "https://www.vmi.lt/evmi/lengvatos-islaidos-kurias-galima-atimti-is-pajamu-21-str.-1"
    }
  },
  {
    question: "Ar galiu pasinaudoti lengvata visai paskolos įmokai?",
    answer: "Ne. Lengvata taikoma tik tai įmokos daliai, kuri padengia paskolos sumą (ne palūkanas). Todėl šis įrankis padeda lengvai atskirti sumas ir paruošti ataskaitą, kuriai įmokos daliai galima taikyti lengvatą."
  },
  {
    question: "Kada pradedate grąžinti paskolą už mokslus Jungtinėje Karalystėje?",
    answer: "Anksčiausiai pradėsite grąžinti:\n\n" +
           "• Balandžio mėn. po to, kai baigiate studijas\n" +
           "• Balandžio mėn. praėjus 4 metams nuo kurso pradžios, jei studijavote neakivaizdiniu būdu\n\n" +
           "Paskolą grąžinsite tik tada, jei uždirbsite daugiau nei jūsų paskolos planui nustatyta atlyginimo riba. Tai reiškia, kad jūsų mokėjimai automatiškai nutrūksta, jei:\n" +
           "• Nustosite dirbti\n" +
           "• Jūsų pajamos tampa mažesnės už nustatytą ribą\n" +
           "• Grąžinsite savo studijų paskolos likutį\n" +
           "• Jūsų studijų paskolos likutis nurašomas\n\n" +
           "Daugiau informacijos: ",
    link: {
      text: "UK Government svetainėje",
      url: "https://www.gov.uk/repaying-your-student-loan"
    }
  },
  {
    question: "Nuo kokios ribos pradedama mokėti įmokas?",
    answer: "Studijų paskolos įmokas pradėsite grąžinti tik tada, jei jūsų atlyginimas viršija grąžinimo ribą. Ši riba priklauso nuo paskolos plano, kurį naudojate, ir kiekvienais metais gali keistis.\n\n" +
           "Detalias ribas galite rasti oficialiuose šaltiniuose:\n\n",
    links: [
      {
        text: "• 1 plano studentų paskoloms",
        url: "https://www.gov.uk/government/publications/overseas-earnings-thresholds-for-plan-1-student-loans/overseas-earnings-thresholds-for-plan-1-student-loans-2024-25"
      },
      {
        text: "• 2 plano studentų paskoloms",
        url: "https://www.gov.uk/government/publications/overseas-earnings-thresholds-for-plan-2-student-loans/overseas-earnings-thresholds-for-plan-2-student-loans-2024-25"
      },
      {
        text: "• Magistrantūros studijų paskoloms",
        url: "https://www.gov.uk/government/publications/overseas-earnings-thresholds-for-postgraduate-student-loans/overseas-earnings-thresholds-for-postgraduate-student-loans-2024-25"
      }
    ]
  },
  {
    question: "Ar galiu deklaruoti ankstesnių metų įmokas?",
    answer: "Taip. Galite papildyti ar tikslinti pajamų deklaracijas už praėjusius 5 kalendorinius metus. Svarbu turėti visus reikalingus dokumentus, patvirtinančius atliktas įmokas.\n\n" +
           "Daugiau informacijos: ",
    link: {
      text: "VMI svetainėje",
      url: "https://www.vmi.lt/evmi/ar-galiu-patikslinti/pateikti-ankstesniu-metu-pajamu-deklaracijas"
    }
  },
  {
    question: "Ar būsiu įsipareigojęs studento paskolai 25–30 metų?",
    answer: "Iš esmės – ne. Nors JK studentų paskolos gali galioti iki 30 metų, jų grąžinimo mechanizmas skiriasi nuo įprastų komercinių paskolų. Grąžinimas vyksta kaip papildomas mokestis nuo pajamų – jūs mokate tik tam tikrą procentą nuo uždarbio, viršijančio nustatytą ribą. Jeigu per paskolos galiojimo laikotarpį visa suma nėra grąžinama, likusi skola yra nurašoma. Todėl ši sistema labiau primena absolventų mokestį nei tradicinę paskolą, ir neturėtų būti vertinama kaip ilgalaikė finansinė našta."
  },
  {
    question: "Kur galiu rasti daugiau informacijos?",
    answer: "Daugiau informacijos galite rasti:",
    links: [
      {
        text: "• Student Loan Company",
        url: "https://www.gov.uk/government/organisations/student-loans-company"
      },
      {
        text: "• VMI",
        url: "https://www.vmi.lt"
      }
    ]
  }
];

const DUK = () => {
  return (
    <>
      {/* Hero Section */}
      <Box sx={{ py: 8, textAlign: 'center', bgcolor: 'background.default' }}>
        <Container maxWidth="md">
          <Typography variant="h2" component="h1" gutterBottom fontWeight="bold">
            Dažniausiai užduodami klausimai
          </Typography>
          <Typography variant="h6" color="text.secondary" paragraph sx={{ mb: 4 }}>
            Raskite atsakymus į populiariausius klausimus apie studentų paskolų deklaravimą
          </Typography>
        </Container>
      </Box>

      {/* FAQ Section */}
      <Container maxWidth="lg" sx={{ mb: 8 }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          {faqItems.map((item, index) => (
            <Accordion 
              key={index} 
              sx={{ 
                '&:not(:last-child)': { mb: 2 },
                '&:before': { display: 'none' },
                boxShadow: 'none',
                border: '1px solid #eaeaea',
                borderRadius: '8px !important',
                overflow: 'hidden'
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ 
                  backgroundColor: 'background.paper',
                  '&:hover': { backgroundColor: '#f8f9fa' }
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  {item.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ backgroundColor: '#f8f9fa' }}>
                <Typography 
                  variant="body1" 
                  color="text.secondary"
                  sx={{ whiteSpace: 'pre-line' }}
                >
                  {item.answer}
                  {item.link && (
                    <Link 
                      href={item.link.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      sx={{ display: 'inline-block' }}
                    >
                      {item.link.text}
                    </Link>
                  )}
                  {item.links && item.links.map((link, linkIndex) => (
                    <Box key={linkIndex} sx={{ display: 'block', mt: linkIndex === 0 ? 1 : 0.5 }}>
                      <Link 
                        href={link.url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                      >
                        {link.text}
                      </Link>
                    </Box>
                  ))}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Paper>
      </Container>
    </>
  );
};

export default DUK; 